import { render, staticRenderFns } from "./Contatti.vue?vue&type=template&id=719ac36a&scoped=true&"
import script from "./Contatti.vue?vue&type=script&lang=js&"
export * from "./Contatti.vue?vue&type=script&lang=js&"
import style0 from "./Contatti.vue?vue&type=style&index=0&id=719ac36a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719ac36a",
  null
  
)

export default component.exports